import { Card, IconButton, makeStyles, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React from "react";
import config from "../../config";
import { dispatch } from "../../events";
import { types } from "../../events/loader";
import { dateTimeToString } from "../../utils/date.utils";
import httpUtils from "../../utils/http.utils";
import BlockUser from "../blockUser";
import Comments from "../comments";
import UserModal from "../userModal";
import UserName from "../userName";


const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative'
    },
    cardMenu: {
        float: 'right'
    },
    image: {
        height: '300px',
        width: '100%',
        objectFit: 'contain'
    },
    text: {
        height: '100px',
        width: '100%',
        overflow: 'auto'
    }
}));

const ITEM_HEIGHT = 48;

const Feed = ({ feed, onDelete }) => {
    const classes = useStyles();

    const [openModal, setOpenModal] = React.useState(false);
    const [openUserDataModal, setOpenUserDataModal] = React.useState(false);


    // Menu
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const deleteFeed = async () => {
        handleMenuClose();
        dispatch(types.SET_LOADER);
        await httpUtils.delete(`${config.BACK_API}/api/feed/${feed.id}`);
        dispatch(types.UNSET_LOADER);
        onDelete(feed);
    }

    const blockUser = async () => {
        handleMenuClose();
        setOpenModal(true);
    }

    const userData = async () => {
        handleMenuClose();
        setOpenUserDataModal(true);
    }

    const deleteReported = async () => {
        handleMenuClose();
        dispatch(types.SET_LOADER);
        await httpUtils.delete(`${config.BACK_API}/api/report/objectId/${feed.id}`);
        dispatch(types.UNSET_LOADER);
        onDelete(feed);
    }

    return (
        <Card className={classes.card}>
            <div>
                <p><UserName user={feed.user}></UserName> - {dateTimeToString(feed.createdAt)}</p>
                <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={handleMenuClick}
                    className={classes.cardMenu}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={openMenu}
                    onClose={handleMenuClose}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                        },
                    }}
                >
                    <MenuItem key="Delete" onClick={deleteFeed}>
                        Delete
                    </MenuItem>
                    <MenuItem key="block" onClick={blockUser}>
                        Block user
                    </MenuItem>
                    <MenuItem key="block" onClick={userData}>
                        User data
                    </MenuItem>
                    {feed.reported && (
                        <MenuItem key="block" onClick={deleteReported}>
                            Delete report
                        </MenuItem>
                    )}
                </Menu>
            </div>
            {!!feed.picture && < img src={feed.picture} className={classes.image}></img>}
            <div className={classes.text}>
                {feed.text}
            </div>
            <Comments objectType={'feed'} objectId={feed.id} />
            {openModal && <BlockUser user={feed.user} onClose={() => setOpenModal(false)} />}
            {openUserDataModal && <UserModal user={feed.user} onClose={() => setOpenUserDataModal(false)} />}

        </Card>
    )
}

export default Feed;